<template>
    <!-- 季度选择时间控件 -->
    <div class="jidudatepicker">
        <mark
                style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;"
                v-show="showSeason"
                @click.stop="showSeason=false"
        ></mark>
        <el-input placeholder="请选择季度" v-model="showValue" style="width:168px;" @focus="showSeason=true" :disabled="!editable">
            <i slot="prefix" class="el-input__icon el-icon-date"></i>
        </el-input>

        <el-card
                class="box-card"
                style="width:322px;padding: 0 3px 20px;margin-top:10px;position:fixed;z-index:9999"
                v-show="showSeason"
        >
            <div slot="header" class="clearfix" style="text-align:center;padding:0">
                <button
                        type="button"
                        aria-label="前一年"
                        class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
                        @click="prev"
                ></button>
                <span role="button" class="el-date-picker__header-label">{{year}}年</span>
                <button
                        type="button"
                        aria-label="后一年"
                        @click="next"
                        class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
                ></button>
            </div>
            <div class="text item" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="width:40%;color: #606266;float:left;"
                        @click="selectSeason(0)"
                >第一季度
                </el-button>
                <el-button
                        type="text"
                        size="medium"
                        style="float:right;width:40%;color: #606266;"
                        @click="selectSeason(1)"
                >第二季度
                </el-button>
            </div>
            <div class="text item" style="text-align:center;">
                <el-button
                        type="text"
                        size="medium"
                        style="width:40%;color: #606266;float:left;"
                        @click="selectSeason(2)"
                >第三季度
                </el-button>
                <el-button
                        type="text"
                        size="medium"
                        style="float:right;width:40%;color: #606266;"
                        @click="selectSeason(3)"
                >第四季度
                </el-button>
            </div>
        </el-card>
    </div>

</template>
<script type="text/javascript">

    export default {
        name: "jududatepicker",
        props: {
            valueArr: {
                default: () => {
                    return ["01-03", "04-06", "07-09", "10-12"];
                },
                type: Array
            },
            valueArr2: {
                default: () => {
                    return ["01", "04", "07", "10"];
                },
                type: Array
            },
            getValue: {
                default: val => {
                    return val;
                },
                type: Function
            },
            defaultValue: {
                default: '',
                type: String
            },
            editable:{
                default:true,
                type:Boolean
            }
        },
        data() {
            return {
                showSeason: false,
                season: '',
                year: new Date().getFullYear(),
                dateValue: this.$route.params.dateValue,
                showValue: this.$route.params.dateValue,
            }
        },
        created() {
            if (this.defaultValue) {
                let value = this.defaultValue
                let arr = value.split('-')
                this.year = arr[0].slice(0, 4)
                let str = arr[1]
                str=parseInt(str)<10?('0'+parseInt(str)):str
                let arrAll = this.valueArr2
                this.showValue = `${this.year}年${arrAll.indexOf(str) + 1}季度`
                this.dateValue = this.year + '-' + arr[1] + "-" + "01"
                let d = new Date(this.year, (parseInt(arr[1]) + 2), 0);
                let startDate = this.year + '-' + arr[1] + "-" + "01";
                let endDate = this.year + "-" + (parseInt(arr[1]) + 2) + "-" + d.getDate();
                this.$emit("fuc", startDate, endDate);
            }
            else this.showValue =''
        },
        watch: {
            defaultValue: function (value, oldValue) {
                let arr = value.split('-')
                this.year = arr[0].slice(0, 4)
                let str = arr[1]
                let arrAll = this.valueArr2
                this.showValue = `${this.year}年${arrAll.indexOf(str) + 1}季度`
                this.dateValue = this.year + '-' + arr[1] + "-" + "01"
                let startDate = this.year + '-' + arr[1] + "-" + "01";
                let d = new Date(this.year, (parseInt(arr[1]) + 2), 0);
                let endDate = this.year + "-" + (parseInt(arr[1]) + 2) + "-" + d.getDate();
                this.$emit("fuc", startDate, endDate);
            }
        },
        methods: {
            one() {
                this.showSeason = false;
            },
            prev() {
                this.year = this.year * 1 - 1;
            },
            next() {
                this.year = this.year * 1 + 1;
            },
            selectSeason(i) {
                let that = this;
                that.season = i + 1;
                let arr = that.valueArr[i].split("-");
                let seasonValue = that.getValue(that.year + "-" + arr[0] + "-" + "01");
                that.showSeason = false;
                this.showValue = `${this.year} 年 ${this.season} 季度`;
                this.dateValue = seasonValue;

                let d = new Date(that.year, arr[1], 0);
                let endDate = that.getValue(that.year + "-" + arr[1] + "-" + d.getDate());
                that.$emit("fuc", seasonValue, endDate); // 每次选择时间都将当前选择时间发送到父组件
                 this.$emit("change", seasonValue);
            }
        }
    };

</script>
<style type="text/css" scoped>
    .jidudatepicker {
        display: inline;
    }

    .text {
        text-align: center;
        margin: 15px 0 10px;
    }

    .item {
        text-align: center;
    }

</style>
<style lang="scss">
    .jidudatepicker {
        .el-card__header {
            padding: 12px;
        }
    }
</style>
